import React from 'react'

const Id = () => {
  return (
    <svg viewBox="0 0 65 65">
      <path fill="#6EC18A" d="M33,48H9c-0.5,0-0.9-0.4-1-0.9c-0.2-1.8,0.6-5.3,4.6-6.2c3.4-0.7,3.4-1.7,3.4-2.3v-1.1c-1.9-1.9-3-4.6-3-7.3
	v-4.5c0-2.1,0.9-4.1,2.4-5.5S19,17.9,21,18c2.1,0,4,0.8,5.5,2.2c1.5,1.5,2.3,3.4,2.4,5.5v4.5c0,2.7-1,5.4-2.9,7.3v1.1
	c0,0.8,0,1.6,3.2,2.3c2.8,0.6,4.8,3.2,4.8,6.1C34,47.6,33.6,48,33,48z M10,46h21.9c-0.3-1.5-1.5-2.8-3.1-3.1c0,0,0,0,0,0
	c-4.4-1-4.8-2.7-4.8-4.3v-1.5c0-0.3,0.1-0.5,0.3-0.7c1.7-1.6,2.6-3.8,2.6-6.2v-4.5c0-1.5-0.6-3-1.8-4.1C24,20.6,22.6,20,21,20
	c-1.6,0-3.1,0.5-4.2,1.6c-1.1,1.1-1.8,2.6-1.8,4.1v4.5c0,2.3,1,4.6,2.7,6.2c0.2,0.2,0.3,0.5,0.3,0.7v1.5c0,1.6-0.6,3.3-5,4.3
	C10.8,43.4,10.2,45,10,46z"/>
      <path fill="#3F5063" d="M57,57H7c-2.8,0-5-2.2-5-5V14c0-2.8,2.2-5,5-5h50c2.8,0,5,2.2,5,5v38C62,54.8,59.8,57,57,57z M7,11
	c-1.7,0-3,1.3-3,3v38c0,1.7,1.3,3,3,3h50c1.7,0,3-1.3,3-3V14c0-1.7-1.3-3-3-3H7z"/>
      <path fill="#3F5063" d="M51,42H37c-0.6,0-1-0.4-1-1s0.4-1,1-1h14c0.6,0,1,0.4,1,1S51.6,42,51,42z M47,34H37c-0.6,0-1-0.4-1-1
	c0-0.6,0.4-1,1-1h10c0.6,0,1,0.4,1,1C48,33.6,47.6,34,47,34z M53,26H37c-0.6,0-1-0.4-1-1s0.4-1,1-1h16c0.6,0,1,0.4,1,1
	S53.6,26,53,26z"/>
    </svg>
  )
}

export default Id
